import { z } from 'zod';

export const statsSchema = z.object({
  placeholder: z.boolean(),
  items: z
    .array(
      z.object({
        value: z.string().min(1),
        label: z.string().min(1),
      }),
    )
    .length(4),
});

export type Stats = z.infer<typeof statsSchema>;
